import React from 'react';
import classNames from 'classnames';
import usePastTime from 'hooks/usePastTime';
import { IconProp } from 'models/Icon';

import './ReportDetails.styles.scss';
import './ReportDetails.styles.responsive.scss';

type ReportDetailsProps = {
  className?: string;
  text: React.ReactNode;
  createdAt: Date;
  icon: IconProp;
};

const ReportDetails: React.FC<ReportDetailsProps> = (props) => {
  const { className, text, createdAt, icon: Icon } = props;

  const classes = classNames('report-details', className);

  const pastTime = usePastTime()(createdAt);

  return (
    <div className={classes}>
      <div className="report-details__main-info">
        <Icon />
        <div>{text}</div>
      </div>
      <div className="report-details__additional-info">{pastTime}</div>
    </div>
  );
};

export default ReportDetails;
